import React from "react";

import { PostCalendar } from "@/components/PostCalendar";
import { useAppContext } from "@/context/AppContext";
import API from "@/services/api";
import CalendarSkeleton from "@/skeleton-1/CalendarSkeleton";

const SchedulePage = () => {
  const { state, loadSchedulelHistory, scheduleLoading } = useAppContext();
  const posts = state.scheduledHistory;
  const handleEditPost = async (id: any, updatedData: any) => {
    try {
      await API.updateScheduledPost(id, updatedData);
      loadSchedulelHistory();
    } catch (error) {
      console.error("Failed to update post:", error);
    }
  };

  const handleDeletePost = async (postId: string) => {
    try {
      await API.deleteScheduledPost(postId);
      loadSchedulelHistory();
    } catch (error) {
      console.error("Failed to delete post:", error);
    }
  };
  return (
    <div className="py-5">
      {scheduleLoading ? (
        <CalendarSkeleton />
      ) : (
        <PostCalendar
          rawScheduledPosts={posts}
          onDeletePost={handleDeletePost}
          onEditPost={handleEditPost}
        />
      )}
    </div>
  );
};

export default SchedulePage;
